module.exports = __webpack_public_path__ + "img/heart_eyes_emoji.1798212.png";